/**
 * Auto-generated feature flag registry.
 *
 * This file is auto-generated from Flipt flag definitions
 * via the codegen script (scripts/generate-registry.ts).
 *
 * DO NOT EDIT MANUALLY — changes will be overwritten.
 *
 * To add a new flag:
 * 1. Define it in the Flipt dashboard
 * 2. Run: pnpm --filter @zep/feature-flag generate
 */

import type { FlagMetadata } from './types';

/**
 * All known feature flag keys, keyed by their identifier.
 * This const object provides compile-time validation of flag keys.
 */
export const FLAG_KEYS = {
  // --- core ---
  CODEIT_EXPERIMENT: {
    key: 'codeit-experiment',
    name: 'Codeit Experiment',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'core',
    description:
      'Enables the Codeit experiment for the codeit-experiment spaces. Returns true for spaceHashId M63drA or O87kO8, false otherwise.',
  },
  DM: {
    key: 'dm',
    name: 'DM',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'core',
    description: '',
  },
  PHASER_V4_UPGRADE: {
    key: 'phaser-v4-upgrade',
    name: 'Phaser V4 Upgrade',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'core',
    description:
      'Phaser 3→4 엔진 업그레이드 롤아웃 제어. 내부 테스터부터 점진적 확대.',
  },
  SCREEN_RECORDING: {
    key: 'screen-recording',
    name: 'Screen Recording',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'core',
    description:
      'Enables Play screen recording independently from Codeit face/absence',
  },
  // --- quiz ---
  QUIZ_BUILD_AI_MODEL_SELECT_DROPDOWN: {
    key: 'quiz_build_ai_model_select_dropdown',
    name: 'quiz_builder_dropdown_ui',
    type: 'BOOLEAN_FLAG_TYPE',
    namespace: 'quiz',
    description:
      '퀴즈 AI로 문제 생성 시 유저가 모델을 선택할 수 있는 UI 노출 여부',
  },
  QUIZ_BUILDER_MODEL_AB: {
    key: 'quiz_builder_model_ab',
    name: 'quiz_builder_model_ab',
    type: 'VARIANT_FLAG_TYPE',
    namespace: 'quiz',
    description: 'Quiz Builder A/B/C 모델 실험',
  },
} as const;

/**
 * Union type of all valid flag key strings.
 * Used to restrict hook/evaluation calls to known flags only.
 */
export type FlagKey = (typeof FLAG_KEYS)[keyof typeof FLAG_KEYS]['key'];

/** All flag metadata entries, derived from FLAG_KEYS to stay in sync. */
export const FLAG_METADATA: readonly FlagMetadata[] = Object.values(FLAG_KEYS);

/** Map of flag key -> metadata for O(1) lookup. */
export const FLAG_METADATA_MAP: Readonly<Record<FlagKey, FlagMetadata>> =
  Object.fromEntries(FLAG_METADATA.map(m => [m.key, m])) as Record<
    FlagKey,
    FlagMetadata
  >;
